module.exports = {"411723001":"古槐街道","411723002":"清河街道","411723003":"东皇街道","411723101":"杨埠镇","411723102":"东和店镇","411723103":"庙湾镇","411723104":"射桥镇","411723105":"西洋店镇","411723106":"阳城镇","411723107":"郭楼镇","411723108":"李屯镇","411723109":"万金店镇","411723110":"高杨店镇","411723111":"万冢镇","411723202":"十字路乡","411723205":"玉皇庙乡","411723208":"老王岗乡","411723209":"辛店乡","411723211":"双庙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411723.json
// module id = 1812
// module chunks = 0